import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('teacher', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getAllteacherExpenseTotal(params) {
    return backofficeService.Api().get('teacher/totalExpense', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`teacher/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
   getStudentTeacherById(id, params = {}) {
    return backofficeService.Api().get(`studentTeacher/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('teacher', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
   
  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
   assignStudent(data) {
    return backofficeService.Api().post(`studentTeacher`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`teacher/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`teacher/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
   removeStudent(id, params) {
    return backofficeService.Api().delete(`studentTeacher/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
